/**
 * Shared trigger for the "Get Support" screen-annotation mode (ReviewMode
 * listens for this event). Used by the red Get Support button in the top
 * bar, the consultant dashboard card, and the Support Launcher's "mark it
 * up" action — one event, one behavior everywhere.
 */
export const OPEN_REVIEW_MODE_EVENT = 'propcloud:open-review-mode';

export function openGetSupport(): void {
  window.dispatchEvent(new CustomEvent(OPEN_REVIEW_MODE_EVENT));
}
